/**
 * Guides mis en avant depuis l'accueil (maillage interne : la page la plus visitée du site pointe vers les articles
 * qui doivent se positionner). Le libellé court sert d'ancre au lien. Partagé avec le pré-rendu de l'accueil ;
 * les slugs sont vérifiés à chaque build (`yarn seo:check`).
 */
export const FEATURED_GUIDES = [
  { slug: "comment-faire-un-diagramme-de-gantt", label: "Comment faire un diagramme de Gantt" },
  { slug: "diagramme-de-gantt-excel", label: "Diagramme de Gantt sur Excel" },
  { slug: "diagramme-de-gantt-google-sheets", label: "Diagramme de Gantt sur Google Sheets" },
  { slug: "diagramme-de-gantt-chatgpt", label: "Faire un Gantt avec ChatGPT" },
  { slug: "modele-planning-projet-gratuit", label: "Modèles de planning de projet" },
  { slug: "dependances-fs-ss-ff-sf-expliquees", label: "Les dépendances FS, SS, FF, SF" },
  { slug: "chemin-critique-methode-cpm", label: "Le chemin critique" },
  { slug: "meilleurs-outils-gantt-2026", label: "Choisir son outil de Gantt" },
];
